import rawCountries from "world-countries";

const formattedCountries = rawCountries
  .map((c) => {
    const name = c.name.common;
    const flag = c.flag || "🏳️";

    let code = "";

    if (c.idd?.root && c.idd?.suffixes?.length > 0) {
      code = c.idd.root + c.idd.suffixes[0];
    }

    return {
      name,
      countryCode: c.cca2,
      flag,
      code
    };
  })
  .filter((c) => c.code !== "")
  .filter(
    (country, index, list) =>
      index ===
      list.findIndex(
        (item) =>
          item.name === country.name &&
          item.code === country.code
      )
  )
  .sort((a, b) =>
    a.name.localeCompare(b.name, "en", {
      sensitivity: "base"
    })
  );

const priorityCountries = [
  { name: "United States", countryCode: "US", code: "+1", flag: "🇺🇸" },
  { name: "Canada", countryCode: "CA", code: "+1", flag: "🇨🇦" },
  { name: "Mexico", countryCode: "MX", code: "+52", flag: "🇲🇽" }
];

const priorityNames = new Set(
  priorityCountries.map((country) => country.name)
);

export const countryList = [
  ...priorityCountries,
  ...formattedCountries.filter(
    (country) => !priorityNames.has(country.name)
  )
];
